export default "__VITE_ASSET__CWMBPr4y__"